import React, { useState, useEffect } from 'react'
import { TimeSeries } from '@scuf/charts'
import { Card, Button, Modal, Icon, InputLabel } from '@scuf/common'
import { useDispatch } from 'react-redux'
import LineData from './LineData'
import LineDataAPI from './LineDataAPI'
import baseServices from '../../../services/base.services';
import { startLineChart } from '../../../actions/entryDataChart'
// import TitlePage from '../../../components/TitlePage/TitlePage';

const Line = ({ url, body, isCard, yAxisTitle, titleCard, randomSeries }) => {

    var date = new Date();
    var last24_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
        date.getUTCHours() - 24, date.getUTCMinutes(), date.getUTCSeconds());

    const dispatch = useDispatch();
    const [state, setState] = useState([])
    const [modal, setModal] = useState(false);


    useEffect(() => {


        const getData = async () => {

            try {
                if (body) {
                    var response = await baseServices.getDataN2(body, url);
                    if (response.data && response.data.length > 0) {
                        //dispatch(startLineChart(response.data[0]))                    

                        setState({ line: LineDataAPI(response) })

                        setTimeout(() => {
                            getData()
                        }, 150000);

                    }
                } else {
                    setState({ line: LineData(randomSeries) })
                    dispatch(startLineChart('dummy data'))
                    setTimeout(() => {
                        getData()
                    }, 150000);
                }

            } catch (err) {
                setTimeout(() => {
                    getData()
                }, 15000);

            }


        }

        getData()

    }, [])




    return (
        <>
            {
                isCard === '1' ?
                    <Card className='m-0'>
                        <Card.Content style={{ minHeight: '0px' }} className='m-0 p-0'>
                            <TimeSeries
                                showRangeSelector={false}
                                showScrollbar={false}
                                showNavigator={false}
                                height={160}
                            >
                                {
                                    state.line && state.line.map((y, i) => (
                                        <TimeSeries.Line spline={true} key={i} name={y.name} data={y.datos} color={y.color} />
                                    ))
                                }

                                <TimeSeries.Title text={titleCard} align='left' />
                                <TimeSeries.Legend enabled={true} align='right' verticalAlign='top' />
                                <TimeSeries.YAxis tickAmount={6} showGridLines={false} top="0%" height="100%" offset={-10} title={{ text: yAxisTitle }} labels={{ format: "" }} />


                            </TimeSeries>
                        </Card.Content>
                    </Card>
                    :
                    <React.Fragment>
                        {
                            modal ?
                                <Modal size="fullscreen" closeIcon={true} onClose={() => setModal(false)} open={modal} closeOnDimmerClick={false} closeOnDocumentClick={false} >
                                    <Modal.Header>
                                        {titleCard}
                                    </Modal.Header>
                                    <Modal.Content>
                                        <TimeSeries
                                            showRangeSelector={true}
                                            showScrollbar={false}
                                            showNavigator={true}
                                            zoom="xy"
                                        >
                                            {
                                                state.line && state.line.map((y, i) => (
                                                    <TimeSeries.Line spline={true} key={i} name={y.name} data={y.datos} color={y.color} />
                                                ))
                                            }

                                            {/* <TimeSeries.Title onClick={() => setState({ open: true, line: state.line })} className='m-0' text={titleCard} align='left' /> */}
                                            <TimeSeries.Legend enabled={true} position='right middle' itemSpacing='small' layout='Vertical' itemStyle={{ "color": "#E0E0E0", "cursor": "pointer", "fontSize": "10px", "fontWeight": "bold", "textOverflow": "ellipsis" }} />
                                            <TimeSeries.YAxis tickAmount={6} showGridLines={false} top="0%" height="100%" offset={-10} title={{ text: yAxisTitle }} labels={{ format: '' }} />

                                        </TimeSeries>
                                    </Modal.Content>
                                    <Modal.Footer>

                                    </Modal.Footer>
                                </Modal>
                                :
                                <div style={{ marginTop: "-15px" }} >
                                    <InputLabel label={titleCard} onClick={() => setModal(true)} />
                                    <TimeSeries
                                        showRangeSelector={false}
                                        showScrollbar={false}
                                        showNavigator={false}
                                        height={160}
                                    >
                                        {
                                            state.line && state.line.map((y, i) => (
                                                <TimeSeries.Line spline={true} key={i} name={y.name} data={y.datos} color={y.color} />
                                            ))
                                        }

                                        {/* <TimeSeries.Title className='m-0' text={titleCard} align='left' /> */}
                                        <TimeSeries.Legend enabled={true} position='right middle' itemSpacing='small' layout='Vertical' itemStyle={{ "color": "#E0E0E0", "cursor": "pointer", "fontSize": "10px", "fontWeight": "bold", "textOverflow": "ellipsis" }} />
                                        <TimeSeries.XAxis min={last24_utc} />
                                        <TimeSeries.YAxis tickAmount={6} showGridLines={false} top="0%" height="100%" offset={-10} title={{ text: yAxisTitle }} labels={{ format: '' }} />

                                    </TimeSeries>
                                </div>
                        }

                    </React.Fragment>
            }
        </>


    )
}

export default Line
